import {useEffect, useState} from "react";
import useCodeInput from "../../../hooks/core/useCodeInput";
import {useSelector} from "react-redux";

const useCustomerCodeInput = () =>  {


  const [noCustomerCode, setNoCustomerCode] = useState(false);
  const { initialValue, codeInputRefs, getEntireCodeFromInput, keyDownHandler, onInputHandler } = useCodeInput();
  const userType = sessionStorage.getItem("userRole");
  const customerId = sessionStorage.getItem("userCode");


  useEffect(() => {
    if (noCustomerCode && codeInputRefs.current) {
      codeInputRefs.current.map(item => {
        item.current.value = "";
      });
    }
  }, [noCustomerCode]);

  useEffect(() => {
    if (userType === 'CONFIGURATION_USER' && customerId) {
      const customerIdArray = customerId.toString().split('');

      // 각 input에 값 설정
      for (let i = 0; i < Math.min(customerIdArray.length, 7); i++) {
        if (codeInputRefs.current[i] && codeInputRefs.current[i].current) {
          codeInputRefs.current[i].current.value = customerIdArray[i];
        }
      }
    }
  }, [userType, customerId]);



  return {
    customerId, userType, initialValue, codeInputRefs, noCustomerCode, keyDownHandler, onInputHandler, setNoCustomerCode, getEntireCodeFromInput
  }
}

export default useCustomerCodeInput;
